"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSubscribeFunction = exports.createPublishFunction = void 0;
//TODO Duplicate from features. This two functions have a similar behavior than features, but they are only a util to facilite events, so we there is no problem to have them duplicated
const createPublishFunction = (channelKey, EventClass) => {
    return (params, eventBus) => {
        const event = new EventClass(params);
        return eventBus === null || eventBus === void 0 ? void 0 : eventBus.publish(channelKey, event);
    };
};
exports.createPublishFunction = createPublishFunction;
const createSubscribeFunction = (channelKey) => {
    return (callback, eventBus) => {
        return eventBus.subscribe(channelKey, event => callback(event.getData()));
    };
};
exports.createSubscribeFunction = createSubscribeFunction;
//# sourceMappingURL=factory.js.map